export default __webpack_public_path__ + "static/media/tutor.5c285bce.png";